<template>
  <file-upload
    :add-files-text="addFilesText"
    :duplicate-check="false"
    :hide-dropzone="true"
    :schema="model"
    @fileAdded="createAttachment"
  />
</template>

<script>
import FileUpload from '@/components/formComponents/FileUpload';
import { AttachmentType } from '@/enums/attachmentType.enum';

// @vuese
// Upload załącznika
// @group Attachment
export default {
  components: { FileUpload },
  props: {
    // Model pola
    model: { type: Object, required: true },
    // Tekst przycisku dodawania pliku
    addFilesText: { type: String, required: false },
    // Dodatkowe metadane ząłącznika
    additionalMetadata: { type: Object, required: false },
    // Typ encji
    entityType: { type: String, required: true },
    // Id encji
    entityId: { type: String, required: true },
    // Typ załącznika
    attachmentType: { type: String, required: false, default: AttachmentType.UPLOADED },
    // Domyślny opis załącznika
    defaultDescription: { type: String, required: false, default: undefined }
  },
  methods: {
    // @vuese
    // Tworzy załącznik
    createAttachment(file) {
      const attachment = {
        mediaId: file.id,
        entityType: this.entityType,
        entityId: this.entityId,
        name: file.name,
        metadata: this.additionalMetadata || undefined,
        type: this.attachmentType
      };

      this.addAttachment(attachment);
    },

    // @vuese
    // Zapisanie pojedyńczego załącznika
    addAttachment(attachment) {
      if (this.defaultDescription && !attachment.description) {
        attachment.description = this.defaultDescription;
      }
      this.$store.dispatch(attachment.entityType + '/attachment/add', attachment).then(id => {
        const addedAttachment = this.$store.getters[attachment.entityType + '/attachment/byId'](id);
        if (addedAttachment.metadata.signature && addedAttachment.metadata.signature.signedBy) {
          this.$emit('signedAttachmentAdded', addedAttachment);
        }
        this.$emit('attachmentAdded', addedAttachment);
      });
    }
  }
};
</script>
